<!-- 缴费记录查询接口内容 -->
<template>
    <div class="">
        <right-structure :Pdatas='infoData'>
            <pre slot="q_code">{{JSON.stringify(requestBody, null, 4)}}</pre>
            <pre slot="r_code">{{JSON.stringify(responseCode, null, 4)}}</pre>
        </right-structure>
    </div>
</template>

<script>
import structure from "@/components/commonStructure";

export default {
  name: "",
  components: {
    "right-structure": structure
  },
  props: ["commonUrls"],
  data() {
    return {
      requestBody: {
          "parkCode": "2KKN885S",
          "parkingCode": "",
          "payTimeStart": "2019-07-25 00:00:00",
          "payTimeEnd": "2019-07-25 23:59:59",
          "pageNum": 1,
          "pageSize": 10
      },
      responseCode: {
    "data": {
        "currCount": 7,
        "recordList": [
            {
                "billCode": "2019072511471720953026",
                "billOriginType": 0,
                "carCode": "粤EJW999",
                "carInTime": "20190724080000",
                "couponList": [
                    {
                        "reliefName": "华润:1.2",
                        "couponOrigin": 0,
                        "reliefValue": 1.2,
                        "id": 1134100016,
                        "reliefType": 3,
                        "couponCode": "378",
                        "parkingBillDetailId": 1600137
                    }
                ],
                "payMode": 4,
                "payModeRemark": "华润微信",
                "payOrigin": 9,
                "payOriginRemark": "华润",
                "payTime": "20190725114717",
                "realValue": 0.8,
                "reliefValue": 0,
                "shoudValue": 2,
                "tollCollctorName": "华润",
                "topBillCode": "190724080000313380085999"
            },
            {
                "billCode": "2019072511533453814538",
                "billOriginType": 0,
                "carCode": "粤A12345",
                "carInTime": "20190724000000",
                "couponList": [
                    {
                        "reliefName": "华润:1.2",
                        "couponOrigin": 0,
                        "reliefValue": 1.2,
                        "id": 1134100017,
                        "reliefType": 3,
                        "couponCode": "379",
                        "parkingBillDetailId": 1600138
                    }
                ],
                "payMode": 4,
                "payModeRemark": "华润微信",
                "payOrigin": 9,
                "payOriginRemark": "华润",
                "payTime": "20190725115334",
                "realValue": 0.8,
                "reliefValue": 0,
                "shoudValue": 2,
                "tollCollctorName": "华润",
                "topBillCode": "190724000000313014906345"
            },
            {
                "billCode": "2019072509180942141928",
                "billOriginType": 0,
                "carCode": "京Y19746",
                "carInTime": "20190723142852",
                "couponList": [
                    {
                        "reliefName": "华润:1.2",
                        "couponOrigin": 0,
                        "reliefValue": 1.2,
                        "id": 1134200010,
                        "reliefType": 3,
                        "couponCode": "374",
                        "parkingBillDetailId": 2000129
                    }
                ],
                "payMode": 4,
                "payOrigin": 9,
                "payOriginRemark": "VEMS",
                "payTime": "20190725091756",
                "realValue": 0.8,
                "reliefValue": 0,
                "shoudValue": 2,
                "tollCollctorName": "华润",
                "topBillCode": "190723142852313940964746"
            },
            {
                "billCode": "2019072510014791933603",
                "billOriginType": 0,
                "carCode": "京Y19746",
                "carInTime": "20190725080000",
                "couponList": [
                    {
                        "reliefName": "当日过遂全免优惠",
                        "couponOrigin": 0,
                        "reliefValue": 0,
                        "id": 1134200011,
                        "reliefType": 3,
                        "couponCode": "375",
                        "parkingBillDetailId": 2000131
                    }
                ],
                "payMode": 1,
                "payOrigin": 9,
                "payOriginRemark": "VEMS",
                "payTime": "20190725100942",
                "realValue": 0,
                "reliefValue": 0,
                "shoudValue": 0,
                "tollCollctorName": "隧e通midllewar",
                "topBillCode": "190725080000313940964746"
            },
            {
                "billCode": "2019072510415119949984",
                "billOriginType": 0,
                "carCode": "京Y19746",
                "carInTime": "20190725080000",
                "couponList": [
                    {
                        "reliefName": "当日过遂全免优惠",
                        "couponOrigin": 0,
                        "reliefValue": 0,
                        "id": 1134200012,
                        "reliefType": 3,
                        "couponCode": "376",
                        "parkingBillDetailId": 2000132
                    }
                ],
                "payMode": 1,
                "payModeRemark": "隧e通支付",
                "payOrigin": 9,
                "payOriginRemark": "隧e通免密支付",
                "payTime": "20190725104151",
                "realValue": 0,
                "reliefValue": 0,
                "shoudValue": 1,
                "tollCollctorName": "隧e通midllewar",
                "topBillCode": "190725080000313940964746"
            },
            {
                "billCode": "2019072510583170125503",
                "billOriginType": 0,
                "carCode": "京Y19722",
                "carInTime": "20190725105718",
                "couponList": [],
                "payMode": 1,
                "payOrigin": 1,
                "payOriginRemark": "VEMS",
                "payTime": "20190725105823",
                "realValue": 0,
                "reliefValue": 0,
                "shoudValue": 0,
                "tollCollctorName": "yz",
                "topBillCode": "190725105718313631898722"
            },
            {
                "billCode": "2019072510595588171142",
                "billOriginType": 0,
                "carCode": "京Y19746",
                "carInTime": "20190725090000",
                "couponList": [
                    {
                        "reliefName": "当日过遂全免优惠",
                        "couponOrigin": 0,
                        "reliefValue": 0,
                        "id": 1134300032,
                        "reliefType": 3,
                        "couponCode": "377",
                        "parkingBillDetailId": 1134600059
                    }
                ],
                "payMode": 1,
                "payModeRemark": "隧e通支付",
                "payOrigin": 9,
                "payOriginRemark": "隧e通免密支付",
                "payTime": "20190725105955",
                "realValue": 0,
                "reliefValue": 0,
                "shoudValue": 1,
                "tollCollctorName": "隧e通midllewar",
                "topBillCode": "190725090000313940964746"
            }
        ],
        "total": 7
    },
    "message": "业务成功",
    "resultCode": 0,
    "status": 1
},
      infoData: {
        explain: "第三方接入系统请求智慧停车开放平台获取缴费记录接口，查询账单详情（对账用）",
        t_url: this.commonUrls.test + "paymentRecordQuery",
        p_url: this.commonUrls.prod + "paymentRecordQuery",
        precondition: "无",
        fitSystem: "VEMS传统停车场, 云停车场",
        pattern: "智慧停车开放平台提供接口, 第三方接入系统主动请求",
        Q_params: [
          {
            titleName: null,
            tabledata: [
              { tableHead: "参数名", tdName: "info1" },
              { tableHead: "是否必填", tdName: "info2" },
              { tableHead: "类型", tdName: "info3" },
              { tableHead: "说明", tdName: "info4" }
            ],
            td: [
              {
                info1: "parkCode",
                info2: "是",
                info3: "String",
                info4: "停车场编号"
              },
              {
                info1: "parkingCode",
                info2: "否",
                info3: "String",
                info4: "停车流水号"
              },
              {
                info1: "payTimeStart",
                info2: "是",
                info3: "String",
                info4: "支付开始时间 yyyy-MM-dd HH:mm:ss"
              },
              {
                info1: "payTimeEnd",
                info2: "是",
                info3: "String",
                info4: "支付结束时间 yyyy-MM-dd HH:mm:ss"
              },
              { info1: "pageNum", info2: "是", info3: "int", info4: "当前页" },
              {
                info1: "pageSize",
                info2: "是",
                info3: "int",
                info4: "每页大小"
              }
            ]
          }
        ],
        R_params: [
          {
            titleName: null,
            tabledata: [
              { tableHead: "参数名", tdName: "info1" },
              { tableHead: "是否必填", tdName: "info2" },
              { tableHead: "类型", tdName: "info3" },
              { tableHead: "说明", tdName: "info4" }
            ],
            td: [
              {
                info1: "total",
                info2: "是",
                info3: "Integer",
                info4: "记录总数"
              },
              {
                info1: "currCount",
                info2: "是",
                info3: "Integer",
                info4: "当前获取的记录数"
              },
              {
                info1: "recordList",
                info2: "是",
                info3: "JSONArray",
                info4: "记录列表"
              }
            ]
          },
          {
            titleName: "recordList",
            tabledata: [
              { tableHead: "参数名", tdName: "info1" },
              { tableHead: "是否必填", tdName: "info2" },
              { tableHead: "类型", tdName: "info3" },
              { tableHead: "说明", tdName: "info4" }
            ],
            td: [
              {
                info1: "billCode",
                info2: "是",
                info3: "String",
                info4: "支付流水号"
              },
              {
                info1: "topBillCode",
                info2: "是",
                info3: "String",
                info4: "停车流水号"
              },
              {
                info1: "thirdBillCode",
                info2: "是",
                info3: "String",
                info4: "第三方流水号（微信、支付宝等）"
              },
              {
                info1: "billOriginType",
                info2: "是",
                info3: "Integer",
                info4: "订单来源，0停车场 1,智慧停车 2、开放平台"
              },
              {
                info1: "carCode",
                info2: "是",
                info3: "String",
                info4: "车牌号"
              },
              {
                info1: "cardCode",
                info2: "是",
                info3: "String",
                info4: "卡号"
              },
              {
                info1: "payTime",
                info2: "是",
                info3: "String",
                info4: "支付时间, yyyyMMddHHmmss"
              },

              {
                info1: "carInTime",
                info2: "是",
                info3: "String",
                info4: "支付时间, yyyyMMddHHmmss"
              },
              {
                info1: "shoudValue",
                info2: "是",
                info3: "Decimal",
                info4: "应收金额"
              },
              {
                info1: "realValue",
                info2: "是",
                info3: "Decimal",
                info4: "实收金额"
              },
              {
                info1: "reliefValue",
                info2: "是",
                info3: "Decimal",
                info4: "优惠减免金额"
              },
              {
                info1: "payMode",
                info2: "是",
                info3: "Integer",
                info4: "支付方式（<url>参考附录:/Api/appendixData</url>）"
              },
              {
                info1: "payOrigin",
                info2: "是",
                info3: "Integer",
                info4: "支付来源（<url>参考附录:/Api/appendixData</url>）"
              },
              {
                info1: "payModeRemark",
                info2: "是",
                info3: "String",
                info4: "支付方式备注"
              },
              {
                info1: "payOriginRemark",
                info2: "是",
                info3: "String",
                info4: "支付来源备注"
              },
              {
                info1: "tollCollctorName",
                info2: "是",
                info3: "String",
                info4: "收费员名称"
              },
              {
                info1: "couponList ",
                info2: "否",
                info3: "JsonArray",
                info4: "支付优惠列表。couponOrigin和reliefType的组合决定优惠的类型：\
                couponOrigin=2 reliefType=0 第三方积分；\
                couponOrigin=2 reliefType=2 第三方优惠（缴费带券）；\
                couponOrigin=2 reliefType=3 第三方优惠；\
                couponOrigin=0 reliefType=0 本地优惠(vems人工优惠)；\
                couponOrigin=0 reliefType=1 电子券优惠；\
                couponOrigin=0 reliefType=2 vems计费系数；\
                couponOrigin=0 reliefType=3 停车场线上活动优惠；\
                couponOrigin=1 reliefType=1 城市运营券优惠；\
                couponOrigin=1 reliefType=2 城市运营积分；"
              }
            ]
          },
          {
            titleName: "couponList",
            tabledata: [
              { tableHead: "参数名", tdName: "info1" },
              { tableHead: "是否必填", tdName: "info2" },
              { tableHead: "类型", tdName: "info3" },
              { tableHead: "说明", tdName: "info4" }
            ],
            td: [
              {
                info1: "couponOrigin",
                info2: "是",
                info3: "int",
                info4: "优惠来源 0停车场 1智慧停车 2第三方定义优惠"
              },
              {
                info1: "reliefType",
                info2: "否",
                info3: "Decimal",
                info4:
                  "与临停缴费上报中的couponType相同。优惠类型：具体对应优惠来源（couponOrigin）所对应的类型, 停车场类型：0本地优惠 1电子券优惠 2vems计费系数 3停车场线上活动优惠，智慧停车类型：1城市运营券优惠 2城市运营积分，第三方类型（针对智慧停车开放平台）：0第三方积分 2第三方优惠（缴费带券） 3第三方优惠"
              },
              {
                info1: "reliefName",
                info2: "否",
                info3: "String",
                info4: "优惠名称"
              },
              {
                info1: "topBillCode",
                info2: "是",
                info3: "String",
                info4: "停车流水号,同parkingCode"
              },
              {
                info1: "reliefValue",
                info2: "否",
                info3: "Decimal",
                info4: "减免金额"
              },


              {
                info1: "couponCode",
                info2: "是",
                info3: "String",
                info4: "优惠编码"
              }
            ]
          }
        ],
        codeStatus: [
          {
            titleName: null,
            tabledata: [
              { tableHead: "状态码", tdName: "info1" },
              { tableHead: "说明", tdName: "info2" }
            ],
            td: [
              { info1: "000110", info2: "失败" },
              { info1: "00110000", info2: "失败" },
              { info1: "110000", info2: "失败" }
            ]
          }
        ]
      }
    };
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
// @import "../../assets/less/conmon.less";
</style>



// WEBPACK FOOTER //
// src/components/Doc/deprecated/parking/paymentRecordQuery.vue